<div class="box">
  <div class="comp"></div>
  <div class="loader"></div>
  <div class="con"></div>
  <div class="byte"></div>
  <div class="server"></div>
</div>